// extracted by mini-css-extract-plugin
module.exports = {"form":"TextMeApp_form__DD_b8","btn":"TextMeApp_btn__X5Y8U","mobile":"TextMeApp_mobile__ItCrX","downlaodBtn":"TextMeApp_downlaodBtn__FZmVn"};